import { ReferringObject } from './ReferringObject';
export class ReferringWorkbench extends ReferringObject {
}
